import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "cs-router-page" }

import { useRoute, useRouter } from "vue-router";
import { computed, ref } from "vue";
import { debug as d } from "debug";
import { CustomRouter, slidingLayerCount } from "./router";
import JyreFooter from "../components/jyre-footer.vue";

import SwipeNavigationInfo from "../components/swipe-navigation-info";
import SlidingRouterView from "../components/sliding-router-view.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'cs-router-view',
  props: {
    name: { default: "default" }
  },
  setup(__props: any) {

const debug = d("cs:router-view");

const route = useRoute();
const router = useRouter();

const props = __props;

const slidingLayerRefs = ref<InstanceType<typeof SlidingRouterView>[]>([]);

function setDynamicRef(el, index) {
  if (el) {
    slidingLayerRefs.value[index - 1] = el;
    // refs.value[index] = el;
  }
}

const leavesImmediately = ref(false);

const showFooter = computed(() => {
  return !(route.meta?.hideFooter ?? false);
});

function back() {
  SwipeNavigationInfo.temporarilyDisable();
  window.history.back();
}

// https://stackoverflow.com/questions/12551920/capturing-all-the-a-click-event
// find first parent with tagName [tagname]
function findParent(tagname: string, initialElement: Element | null) {
  let el = initialElement;
  while (el) {
    const name = el.nodeName || el.tagName;
    if (name && name.toLowerCase() === tagname.toLowerCase()) {
      return el;
    }
    el = el.parentNode as Element;
  }
  return null;
}

function click(event: MouseEvent | KeyboardEvent) {
  const e = event || window.event;
  const ele = findParent("a", (e.target || e.srcElement) as Element);
  if (ele && ele.getAttribute && !ele.getAttribute("target")) {
    const href = ele.getAttribute("href");
    (router as CustomRouter).handleClick(href, e as MouseEvent);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["cs-router-view", { 'slide-leave-immediately': leavesImmediately.value }]),
    onClick: click
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          _createVNode(_Transition, {
            name: "fade",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                ref: "default",
                key: _unref(route).path
              }))
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      })
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(slidingLayerCount), (i) => {
      return (_openBlock(), _createBlock(SlidingRouterView, {
        key: 'sliding' + i,
        ref_for: true,
        ref: (el) => setDynamicRef(el, i),
        name: 'sliding' + i
      }, null, 8, ["name"]))
    }), 128)),
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (showFooter.value)
          ? (_openBlock(), _createBlock(JyreFooter, {
              key: _unref(route).path
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}
}

})